export const UPDATE = 'ksk001/estateOverviewFiltersReady/UPDATE'

export const initialState = false

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case UPDATE:
      return payload.value
    default:
      return state
  }
}

export const update = value => dispatch =>
  dispatch({
    type: UPDATE,
    payload: { value },
  })
